module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_7016.5f1fa69d.png";